const TYPE = `[ADMIN]`;

const Types = {
    // Stats
    FETCH_STATS_START: `${TYPE} FETCH STATS START`,
    FETCH_STATS_SUCCESS: `${TYPE} FETCH STATS SUCCESS`,
    FETCH_STATS_ERROR: `${TYPE} FETCH STATS ERROR`,
    
    // Users
    FETCH_USERS_START: `${TYPE} FETCH USERS START`,
    FETCH_USERS_SUCCESS: `${TYPE} FETCH USERS SUCCESS`,
    FETCH_USERS_ERROR: `${TYPE} FETCH USERS ERROR`,

    FETCH_USER_BY_ID_START: `${TYPE} FETCH USER BY ID START`,
    FETCH_USER_BY_ID_SUCCESS: `${TYPE} FETCH USER BY ID SUCCESS`,
    FETCH_USER_BY_ID_ERROR: `${TYPE} FETCH USER BY ID ERROR`,

    UPDATE_USER_START: `${TYPE} UPDATE USER START`,
    UPDATE_USER_SUCCESS: `${TYPE} UPDATE USER SUCCESS`,
    UPDATE_USER_ERROR: `${TYPE} UPDATE USER ERROR`,

    DELETE_USER_START: `${TYPE} DELETE USER START`,
    DELETE_USER_SUCCESS: `${TYPE} DELETE USER SUCCESS`,
    DELETE_USER_ERROR: `${TYPE} DELETE USER ERROR`,

    TOGGLE_USER_STATUS_START: `${TYPE} TOGGLE USER STATUS START`,
    TOGGLE_USER_STATUS_SUCCESS: `${TYPE} TOGGLE USER STATUS SUCCESS`,
    TOGGLE_USER_STATUS_ERROR: `${TYPE} TOGGLE USER STATUS ERROR`,

    RESET_USER_PASSWORD_START: `${TYPE} RESET USER PASSWORD START`,
    RESET_USER_PASSWORD_SUCCESS: `${TYPE} RESET USER PASSWORD SUCCESS`,
    RESET_USER_PASSWORD_ERROR: `${TYPE} RESET USER PASSWORD ERROR`,
    
    // Therapists — Pending
    FETCH_PENDING_THERAPISTS_START: `${TYPE} FETCH PENDING THERAPISTS START`,
    FETCH_PENDING_THERAPISTS_SUCCESS: `${TYPE} FETCH PENDING THERAPISTS SUCCESS`,
    FETCH_PENDING_THERAPISTS_ERROR: `${TYPE} FETCH PENDING THERAPISTS ERROR`,

    APPROVE_THERAPIST_START: `${TYPE} APPROVE THERAPIST START`,
    APPROVE_THERAPIST_SUCCESS: `${TYPE} APPROVE THERAPIST SUCCESS`,
    APPROVE_THERAPIST_ERROR: `${TYPE} APPROVE THERAPIST ERROR`,

    REJECT_THERAPIST_START: `${TYPE} REJECT THERAPIST START`,
    REJECT_THERAPIST_SUCCESS: `${TYPE} REJECT THERAPIST SUCCESS`,
    REJECT_THERAPIST_ERROR: `${TYPE} REJECT THERAPIST ERROR`,
    
    // Therapists — All (filterable)
    FETCH_THERAPISTS_START: 'admin/FETCH_THERAPISTS_START',
    FETCH_THERAPISTS_SUCCESS: 'admin/FETCH_THERAPISTS_SUCCESS',
    FETCH_THERAPISTS_FAIL: 'admin/FETCH_THERAPISTS_FAIL',

    // Reviews
    FETCH_REVIEWS_START: `${TYPE} FETCH REVIEWS START`,
    FETCH_REVIEWS_SUCCESS: `${TYPE} FETCH REVIEWS SUCCESS`,
    FETCH_REVIEWS_ERROR: `${TYPE} FETCH REVIEWS ERROR`,

    MODERATE_REVIEW_START: `${TYPE} MODERATE REVIEW START`,
    MODERATE_REVIEW_SUCCESS: `${TYPE} MODERATE REVIEW SUCCESS`,
    MODERATE_REVIEW_ERROR: `${TYPE} MODERATE REVIEW ERROR`,

    RESET_ERROR: `${TYPE} RESET ERROR`,

    // Businesses
    FETCH_BUSINESSES_START: `${TYPE} FETCH BUSINESSES START`,
    FETCH_BUSINESSES_SUCCESS: `${TYPE} FETCH BUSINESSES SUCCESS`,
    FETCH_BUSINESSES_ERROR: `${TYPE} FETCH BUSINESSES ERROR`,

    FETCH_BUSINESS_BY_ID_START: `${TYPE} FETCH BUSINESS BY ID START`,
    FETCH_BUSINESS_BY_ID_SUCCESS: `${TYPE} FETCH BUSINESS BY ID SUCCESS`,
    FETCH_BUSINESS_BY_ID_ERROR: `${TYPE} FETCH BUSINESS BY ID ERROR`,

    UPDATE_BUSINESS_START: `${TYPE} UPDATE BUSINESS START`,
    UPDATE_BUSINESS_SUCCESS: `${TYPE} UPDATE BUSINESS SUCCESS`,
    UPDATE_BUSINESS_ERROR: `${TYPE} UPDATE BUSINESS ERROR`,

    UPDATE_BUSINESS_STATUS_START: `${TYPE} UPDATE BUSINESS STATUS START`,
    UPDATE_BUSINESS_STATUS_SUCCESS: `${TYPE} UPDATE BUSINESS STATUS SUCCESS`,
    UPDATE_BUSINESS_STATUS_ERROR: `${TYPE} UPDATE BUSINESS STATUS ERROR`,

    CREATE_BUSINESS_START: `${TYPE} CREATE BUSINESS START`,
    CREATE_BUSINESS_SUCCESS: `${TYPE} CREATE BUSINESS SUCCESS`,
    CREATE_BUSINESS_ERROR: `${TYPE} CREATE BUSINESS ERROR`,

    DELETE_BUSINESS_START: `${TYPE} DELETE BUSINESS START`,
    DELETE_BUSINESS_SUCCESS: `${TYPE} DELETE BUSINESS SUCCESS`,
    DELETE_BUSINESS_ERROR: `${TYPE} DELETE BUSINESS ERROR`,

    BULK_DELETE_BUSINESSES_START: `${TYPE} BULK DELETE BUSINESSES START`,
    BULK_DELETE_BUSINESSES_SUCCESS: `${TYPE} BULK DELETE BUSINESSES SUCCESS`,
    BULK_DELETE_BUSINESSES_ERROR: `${TYPE} BULK DELETE BUSINESSES ERROR`,

    BULK_UPDATE_BUSINESS_STATUS_START: `${TYPE} BULK UPDATE BUSINESS STATUS START`,
    BULK_UPDATE_BUSINESS_STATUS_SUCCESS: `${TYPE} BULK UPDATE BUSINESS STATUS SUCCESS`,
    BULK_UPDATE_BUSINESS_STATUS_ERROR: `${TYPE} BULK UPDATE BUSINESS STATUS ERROR`,

    // User bulk actions
    BULK_DELETE_USERS_START: `${TYPE} BULK DELETE USERS START`,
    BULK_DELETE_USERS_SUCCESS: `${TYPE} BULK DELETE USERS SUCCESS`,
    BULK_DELETE_USERS_ERROR: `${TYPE} BULK DELETE USERS ERROR`,

    BULK_TOGGLE_USERS_START: `${TYPE} BULK TOGGLE USERS START`,
    BULK_TOGGLE_USERS_SUCCESS: `${TYPE} BULK TOGGLE USERS SUCCESS`,
    BULK_TOGGLE_USERS_ERROR: `${TYPE} BULK TOGGLE USERS ERROR`,

    HARD_DELETE_USER_START: `${TYPE} HARD DELETE USER START`,
    HARD_DELETE_USER_SUCCESS: `${TYPE} HARD DELETE USER SUCCESS`,
    HARD_DELETE_USER_ERROR: `${TYPE} HARD DELETE USER ERROR`,

    BULK_HARD_DELETE_USERS_START: `${TYPE} BULK HARD DELETE USERS START`,
    BULK_HARD_DELETE_USERS_SUCCESS: `${TYPE} BULK HARD DELETE USERS SUCCESS`,
    BULK_HARD_DELETE_USERS_ERROR: `${TYPE} BULK HARD DELETE USERS ERROR`,

    // Create User (admin)
    CREATE_USER_START: `${TYPE} CREATE USER START`,
    CREATE_USER_SUCCESS: `${TYPE} CREATE USER SUCCESS`,
    CREATE_USER_ERROR: `${TYPE} CREATE USER ERROR`,

    // Restore User
    RESTORE_USER_START: `${TYPE} RESTORE USER START`,
    RESTORE_USER_SUCCESS: `${TYPE} RESTORE USER SUCCESS`,
    RESTORE_USER_ERROR: `${TYPE} RESTORE USER ERROR`,
}

export default Types;
